import { Grid } from '@mui/material';
import React, { useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import ComponentPageHeader from '../../Common/PageHeader/ComponentPageHeader';
import DataTable from '../../Common/DataTable';
import { RecommendationsData } from './utils/types';
import { RootState } from '../../redux/rootState';
import { getRecommendationsStart } from './redux/recommendationSlice';
import { setLoader } from '../../redux/loaderSlice';
import {
  resetPagination, setPageNumber, setPageSize, setSearchParam,
} from '../taiReportingSystem/redux/sliceReportWorkspace';

function ScreenRecommendations() {
  const Navigate = useNavigate();
  // const [page, setPage] = useState(1);
  // const [rowsPerPage, setRowsPerPage] = useState(10);
  // const [searchQuery, setSearchQuery] = useState('');
  const {
    pageNumber, pageSize, searchParam,
  } = useSelector((state: RootState) => state.reportWorkspaceReducer);
  const { historyStack } = useSelector((state:RootState) => state.masterDataReducer);

  const { recommendations, totalRecommendations, isLoading } = useSelector((state:RootState) => state.recommendationReducer);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setLoader(isLoading));
  }, [isLoading]);

  const handleData = () => {
    const params = {
      page: pageNumber,
      rowsPerPage: pageSize,
      searchQuery: searchParam,
    };
    dispatch(getRecommendationsStart(params));
  };

  useEffect(() => {
    handleData();
  }, [pageNumber, pageSize, searchParam]);

  const data: RecommendationsData[] = useMemo(() => recommendations?.map((item, index) => {
    const transformedDataItem = {
      jobOrder: item.JobOrder,
      action: 'edit',
      sn: index,
      id: item.JobOrder,
    };
    return transformedDataItem;
  }), [recommendations]);

  const columns = useMemo(
    () => [
      // { key: 'sn', label: 'SN' },
      { key: 'action', label: 'Action' },
      { key: 'jobOrder', label: 'Job Order' },
    ],
    [],
  );

  const handleEdit = (id: string) => {
    Navigate(`${id}`);
  };

  useEffect(() => {
    if (historyStack) {
      const finderString = '/recommendations/';
      const last = historyStack[historyStack.length - 1];
      const sLast = historyStack[historyStack.length - 2];
      if (!(
        last?.includes(finderString)
          || (sLast?.includes(finderString) && last === '/recommendations')
      )) {
        dispatch(resetPagination());
      }
    }
  }, [historyStack]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={12} md={12}>
        <ComponentPageHeader subHeading="Recommendations" />
      </Grid>
      <Grid item xs={12} sm={12} md={12} className="dataTableCustomMargin">
        <DataTable<RecommendationsData>
          data={data}
          columns={columns}
          totalRecords={totalRecommendations}
          page={pageNumber}
          setPage={(e) => { dispatch(setPageNumber(e)); }}
          rowsPerPage={pageSize}
          setRowsPerPage={(e) => { dispatch(setPageSize(e)); }}
          searchQuery={searchParam}
          setSearchQuery={(e) => { dispatch(setSearchParam(e)); dispatch(setPageNumber(1)); }}
          handleData={handleData}
          handleEdit={handleEdit}
          handleDataFromComponent
        />
      </Grid>
    </Grid>
  );
}

export default ScreenRecommendations;
